module.exports = __webpack_public_path__ + "static/media/Human_ZG5850-Edit_720.d047ceaa.jpeg";